export default "__VITE_ASSET__5764ee06__"